
/**
 * Télécharge une image depuis une URL et l'upload vers l'API.
 * 
 * @param {string} API_BASE URL de base de l'API
 * @param {string} token Token d'authentification
 * @param {string} imageUrl URL de l'image externe
 * @param {number|string} manifestationId ID de la manifestation à lier
 * @returns {Promise<string>} URL de l'image uploadée
 */
async function uploadImageFromUrl(API_BASE, token, imageUrl, manifestationId) {
    try {
        // 1. Récupérer l'image sous forme de Blob
        const response = await fetch(imageUrl);
        if (!response.ok) {
            throw new Error(`Impossible de récupérer l'image depuis ${imageUrl}`);
        }
        const blob = await response.blob();

        // 2. Créer un objet File à partir du Blob (optionnel mais propre)
        // On essaie de deviner l'extension via le content-type
        const contentType = response.headers.get('content-type') || 'image/jpeg';
        let extension = 'jpg';
        if (contentType.includes('png')) extension = 'png';
        if (contentType.includes('gif')) extension = 'gif';
        if (contentType.includes('webp')) extension = 'webp';

        const filename = `cover_${manifestationId}.${extension}`;
        const file = new File([blob], filename, { type: contentType });

        // 3. Préparer le FormData
        const formData = new FormData();
        formData.append('file', file);
        formData.append('manifestation_id', manifestationId);

        // 4. Envoyer à l'API d'upload
        const uploadRes = await fetch(`${API_BASE}/upload`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: formData
        });

        if (!uploadRes.ok) {
            throw new Error("Erreur lors de l'upload de l'image : " + (await uploadRes.text()));
        }

        const data = await uploadRes.json();
        return data.url || data.path;

    } catch (error) {
        console.error("Erreur dans uploadImageFromUrl:", error);
        throw error;
    }
}

export default uploadImageFromUrl;
